import React, {Component} from 'react';

import Search from "../core/Search";

class Observations extends Component {

    constructor(props) {
        super(props);

        this.externalCall = this.externalCall.bind(this);
    }

    externalCall(method) {
        if (method === "addObservation") {
            this.props.history.push('/admin/observation/');
        }
    }

    render() {
        return (
            <Search
                initData={{DATAGRID_SCREEN_ID: 106}}
                externalCall={this.externalCall} />
        );
    }
}

export default Observations;
